export interface ICheckGroup {
  groupID: string;
  questions: string[];
  title?: string;
  translations?: string;
}

export interface ICheck {
  active: number;
  checkGroups: ICheckGroup[];
  checkID: string;
  checkType: number;
  created: number;
  creator: number;
  description: string;
  disabledAt: string;
  disabledBy: string;
  identifier: string;
  isOperational: number;
  lastUpdate: number;
  locations: number[];
  operationalDataType: string;
  powerpoints: number;
  presentation: string;
  readOnly: number;
  revision: number;
  title: string;
  translations: any;
  status?: string;
  subject?: CheckSubject;
}

export enum CheckSubject {
  Assets = 'assets',
  Zones = 'zones',
  Workers = 'workers'
}
